/*
 *
 * AbsenceDetail constants
 *
 */

// LOAD List
export const LOAD_ABSENCE = 'app/AbsenceDetail/LOAD_ABSENCE';
export const LOAD_ABSENCE_SUCCESS = 'app/AbsenceDetail/LOAD_ABSENCE_SUCCESS';
export const LOAD_ABSENCE_ERROR = 'app/AbsenceDetail/LOAD_ABSENCE_ERROR';

// CHANGE UPDATE
export const CHANGE_ABSENCE = 'app/AbsenceDetail/CHANGE_ABSENCE';
export const CHANGE_ABSENCE_SUCCESS = 'app/AbsenceDetail/CHANGE_ABSENCE_SUCCESS';
export const CHANGE_ABSENCE_ERROR = 'app/AbsenceDetail/CHANGE_ABSENCE_ERROR';

// DELETE
export const DELETE_ABSENCE = 'app/AbseAbsenceDetailnce/DELETE_ABSENCE';
export const DELETE_ABSENCE_SUCCESS = 'app/AbsenceDetail/DELETE_ABSENCE_SUCCESS';
export const DELETE_ABSENCE_ERROR = 'app/AbsenceDetail/DELETE_ABSENCE_ERROR';

export const FLUSH_STATE_ABSENCEDETAIL = 'app/AbsenceDetail/FLUSH_STATE_ABSENCEDETAIL';

// absence house
// Absence House
// ABSENCE HOUSE
